import { ApiResponse, axiosInstance, AxiosErrorCustom } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { ILabelCustomer } from '@/features/settings/label/label-customer/types/label-customer.type';

export const ResolveCasesInputSchema = z.object({
  caseIds: z
    .array(z.string({ required_error: 'Case ID is required!' }).min(1))
    .min(1, { message: 'At least one case ID is required!' }),
});
export type TResolveCasesInput = z.infer<typeof ResolveCasesInputSchema>;
export type TResolveCasesResponse = ApiResponse<ILabelCustomer>;

export const resolveCases = async (data: TResolveCasesInput): Promise<TResolveCasesResponse> => {
  const url = `/chat/resolve-case`;

  return axiosInstance.post(url, data);
};

type UseResolveCasesOptions = {
  mutationConfig?: TypedMutationConfig<typeof resolveCases, AxiosErrorCustom>;
};

export const useResolveCases = ({ mutationConfig }: UseResolveCasesOptions) => {
  const { onError, ...rest } = mutationConfig || {};

  return useMutation<TResolveCasesResponse, AxiosErrorCustom, TResolveCasesInput>({
    ...rest,
    mutationFn: resolveCases,
    onError,
  });
};
